module.exports = __webpack_public_path__ + "images/186_2048.jpg";